import React, { useState } from 'react';
import {
  ItemHeader,
  ArrowUp,
  ArrowDown,
} from './modal-list-item.styles';

const ModalListItem = ({ label, children }) => {
  const [show, setShow] = useState(false);

  return (
    <div>
      <ItemHeader onClick={() => setShow((prev) => !prev)} $expanded={show}>
        <span>{!show ? <ArrowUp /> : <ArrowDown />}</span>
        <span>{label}</span>
      </ItemHeader>
      {show && <div>{children}</div>}
    </div>
  );
};

export default ModalListItem;
